// src/components/ui/PageTransition/styles.ts
import styled, { css, keyframes } from "styled-components";

const pageEnter = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// IMPORTANTE: a animação precisa ser removida ao terminar ($done). Enquanto o
// wrapper tiver um transform ativo (mesmo translateY(0), retido pelo
// fill-mode), ele vira containing block dos descendentes position:fixed —
// BottomSheet/LoadingOverlay passariam a ancorar no fim do documento em vez
// do viewport e "sumiriam" da tela.
export const PageEnter = styled.div<{ $done?: boolean }>`
  animation: ${pageEnter} 0.32s ${(p) => p.theme.tokens.transition.spring} both;

  ${(p) =>
    p.$done &&
    css`
      animation: none;
    `}

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
